import { Switch, Route } from "react-router-dom";
import AtendimentoAssistenciaTecnica from "../../Pages/AssistenciaTecnica/Atendimento";
import { GestaoAssitenciaTecnica } from "../../Pages/AssistenciaTecnica/GestaoAtendimento/GestaoAssistenciaTecnica";
import RelatoriosBIAssistencia from "../../Pages/AssistenciaTecnica/RelatoriosBI";
import ModuloADS from "../../Pages/ModuloAds";
import { ACESSOS } from "../Acessos";
import PrivatedRoute from "../PrivatedRoute";
import { TriagemEmails } from "../../Pages/Geral/Triagem";
import CustoOficialRelotoriosBI from "../../Pages/AssistenciaTecnica/CustoOficialRelatoriosBI";
import CustoEncarregadoRelatoriosBI from "../../Pages/AssistenciaTecnica/CustoEncarregadoRelatoriosBI";
import CadastroDeDirecionamento from "../../Pages/AssistenciaTecnica/CadastroDirecionamento";
import CustoPrevistoVGVMensalRelatoriosBI from "../../Pages/AssistenciaTecnica/CustoPrevistoVGVMensalRelatoriosBI";
import CustosPrevistosVGVRelatoriosBI from "../../Pages/AssistenciaTecnica/CustoPrevistoVGVRelatoriosBI";

export default function RotasAssistencia() {
    return (
        <Switch>
            <PrivatedRoute
                path={ACESSOS.ASSISTENCIA.TELAS.DASHBOARD.DS_PATH}
                component={() => <></>}
                isPrivate
                idModulo={ACESSOS.ASSISTENCIA.ID_MODULO}
                idTela={ACESSOS.ASSISTENCIA.TELAS.DASHBOARD.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.ASSISTENCIA.TELAS.ATENDIMENTO.DS_PATH}
                component={AtendimentoAssistenciaTecnica}
                idModulo={ACESSOS.ASSISTENCIA.ID_MODULO}
                isPrivate
                idTela={ACESSOS.ASSISTENCIA.TELAS.ATENDIMENTO.ID_TELA}
            />
            <PrivatedRoute
                path={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS.TODOS.DS_PATH
                }
                component={GestaoAssitenciaTecnica.TodosAtendimentos}
                isPrivate
                idModulo={ACESSOS.ASSISTENCIA.ID_MODULO}
                idTela={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS.TODOS.ID_TELA
                }
            />
            <PrivatedRoute
                path={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS
                        .MEUS_ATENDIMENTOS.DS_PATH
                }
                component={GestaoAssitenciaTecnica.MeusAtendimentos}
                isPrivate
                idModulo={ACESSOS.ASSISTENCIA.ID_MODULO}
                idTela={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS
                        .MEUS_ATENDIMENTOS.USUARIO.ID_TELA
                }
            />
            <PrivatedRoute
                path={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS.GRUPO.DS_PATH
                }
                component={GestaoAssitenciaTecnica.GrupoAtendimentos}
                isPrivate
                idModulo={ACESSOS.ASSISTENCIA.ID_MODULO}
                idTela={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS.GRUPO.ID_TELA
                }
            />
            <PrivatedRoute
                path={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS.CAPYS_BI
                        .DS_PATH
                }
                idModulo={ACESSOS.ASSISTENCIA.ID_MODULO}
                component={RelatoriosBIAssistencia}
                isPrivate
                idTela={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS.CAPYS_BI
                        .ID_TELA
                }
            />
            <PrivatedRoute
                path={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS
                        .CAPYS_BI_CUSTO_OFICIAL.DS_PATH
                }
                idModulo={ACESSOS.ASSISTENCIA.ID_MODULO}
                component={CustoOficialRelotoriosBI}
                isPrivate
                idTela={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS
                        .CAPYS_BI_CUSTO_OFICIAL.ID_TELA
                }
            />
            <PrivatedRoute
                path={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS
                        .CAPYS_BI_CUSTO_PREVISTO_VGV.DS_PATH
                }
                idModulo={ACESSOS.ASSISTENCIA.ID_MODULO}
                component={CustosPrevistosVGVRelatoriosBI}
                isPrivate
                idTela={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS
                        .CAPYS_BI_CUSTO_PREVISTO_VGV.ID_TELA
                }
            />
            <PrivatedRoute
                path={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS
                        .CAPYS_BI_CUSTO_PREVISTO_VGV_MENSAL.DS_PATH
                }
                idModulo={ACESSOS.ASSISTENCIA.ID_MODULO}
                component={CustoPrevistoVGVMensalRelatoriosBI}
                isPrivate
                idTela={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS
                        .CAPYS_BI_CUSTO_PREVISTO_VGV_MENSAL.ID_TELA
                }
            />
            <PrivatedRoute
                path={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS
                        .CAPYS_BI_CUSTO_ENCARREGADO.DS_PATH
                }
                idModulo={ACESSOS.ASSISTENCIA.ID_MODULO}
                component={CustoEncarregadoRelatoriosBI}
                isPrivate
                idTela={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS
                        .CAPYS_BI_CUSTO_ENCARREGADO.ID_TELA
                }
            />
            <PrivatedRoute
                path={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS
                        .CAPYS_BI_CADASTRO_DIRECIONAMENTO.DS_PATH
                }
                idModulo={ACESSOS.ASSISTENCIA.ID_MODULO}
                component={CadastroDeDirecionamento}
                isPrivate
                idTela={
                    ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS
                        .CAPYS_BI_CADASTRO_DIRECIONAMENTO.ID_TELA
                }
            />
            <PrivatedRoute
                path={ACESSOS.ASSISTENCIA.TELAS.TRIAGEM.DS_PATH}
                idModulo={ACESSOS.ASSISTENCIA.ID_MODULO}
                component={TriagemEmails}
                isPrivate
                idTela={ACESSOS.ASSISTENCIA.TELAS.TRIAGEM.ID_TELA}
            />
            <Route
                path="/AssistenciaTecnica/:idModulo/"
                exact
                component={ModuloADS}
            />
        </Switch>
    );
}
